<template>
  <v-content class="purchase">
    <div class="pa-3" v-if="data">
        <v-expansion-panels v-model="panel[index]" :disabled="disabled" v-for="(items,index) in data" :key="index" class="">
          <v-expansion-panel class="">
            <v-expansion-panel-header class="selecthead px-4">
              {{index}}
              <template v-slot:actions><v-icon color="#9D9D9D">mdi-chevron-down</v-icon></template>
            </v-expansion-panel-header>
            <div class="selectwrap">
            <v-expansion-panel-content v-for="(item,index) in items" :key="index" class="mb-3">
              <v-card class="mx-auto py-0 pl-0" @click="routerBindTo({ name: 'purchase-external-detail', query: { card_number: item.card_number ,purchase_date: item.purchase_date ,purchase_shop_code: item.purchase_shop_code, register_num: item.register_num, receipt_num: item.receipt_num}})">
                <v-row class="flex-nowrap" no-gutters align="center">
                  <v-col cols="11" class="pl-3">
                    <p class="mb-2 bold">{{item.purchase_shop_name}}</p>
                    <p class="overline">ご購入日：{{getDateFormat(item.purchase_date)}}</p>
                    <p class="overline">レシートNo：{{item.receipt_num}}</p>
                    <p :class="{'red--text': item.purchase_total<0 }" class="mb-2 bold text-right">{{Number(item.purchase_total).toLocaleString()}}円(税込)</p>
                    <p :class="{'red--text': item.purchase_point<0 }" class="overline mb-2 text-right">(ポイント付与：{{item.purchase_point}}P)</p>
                  </v-col>
                  <v-col cols="1" class="pa-0">
                    <v-icon x-small right class="maincolor">fas fa-chevron-right</v-icon>
                  </v-col>
                </v-row>
              </v-card>
            </v-expansion-panel-content>
            </div>
          </v-expansion-panel>
        </v-expansion-panels>
      </div>
    <infinite-loading ref="infiniteLoading" spinner="spiral" v-else-if="data === null">
      <div slot="spinner"><v-progress-circular :size="30" :width="2" class="maincolor" indeterminate></v-progress-circular></div>
      <div slot="no-more"></div>
      <div slot="no-results">購入履歴はありません</div>
    </infinite-loading>
    <v-overlay :value="loading">
      <v-progress-circular :size="80" :width="2" class="maincolor" indeterminate></v-progress-circular>
    </v-overlay>

  </v-content>
</template>

<script>
import InfiniteLoading from 'vue-infinite-loading'
import moment from "moment"
export default {
  components: {
    InfiniteLoading,
  },
  data: () => ({
    init: [],
    data: [],
    panel: [0],
    loading: false,
    disabled: false,
  }),
  async created () {
    this.init = this.storageGet('*')
    if(this.init.external_flg === 1) {
      await this.$router.replace({
        name: 'purchase-external-ldx-list',
        query: this.$route.query,
        force: true
      }).then(() => {
        return false;
      });
    }
    this.loading = true
    try {
      // 外部購買履歴(リスト)取得API
      let req = {params: {
          'shop_id': this.init.sid,
          'user_id': this.init.user_id,
        }}

      let res = await this.apiCall('/purchase-external/csdelight-list', req);
      if (!res){
        this.loading = false
        return false;
      }
      this.$set(this, 'data', res.items);
      if(this.data === null){
        setTimeout(() => {
          this.$refs.infiniteLoading.stateChanger.complete()
        }, 10);
      }else{
        // 先頭項目のみアコーディオンを開いた状態にする
        let initPanel = 0;
        Object.keys(this.data).forEach(function(key) {
          this[key] = initPanel
          // 先頭項目以外はアコーディオンを閉じた状態にする
          initPanel = 1
        }, this.panel);
      }
      this.loading = false
    }catch (e) {
      this.loading = false
      this.callDialog('接続エラー', '一時的なエラーです。ネットワークの状態が不安定です。再度お試しください', 3);
    }
  },
  methods: {
    getDateFormat: function(item) {
      return moment(item).format('YYYY年M月D日')
    }
  },
}
</script>

<style scoped>
.v-expansion-panel--active > .v-expansion-panel-header {
  min-height: 48px !important;
  margin-bottom: 8px;
}
.v-expansion-panels{
  border-radius: 22px !important;
}
.v-expansion-panel-header:before{
  opacity: 0.1 !important;
  border-radius: 22px !important;
}
.v-application .overline {
  word-break: break-all !important;
  line-height: 1rem;
  margin-bottom: 0px
}
.v-application .bold {
  font-weight: bold;
}
.v-item--active >>> .selectwrap {
  margin-bottom: 20px;
  border-radius: 22px;
  border: none;
  background: #fff;
  box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.2);
}
.v-expansion-panels:not(.v-expansion-panels--accordion):not(.v-expansion-panels--tile)>.v-expansion-panel--active+.v-expansion-panel,
.v-expansion-panels:not(.v-expansion-panels--accordion):not(.v-expansion-panels--tile)>.v-expansion-panel--next-active {
  border-radius: 22px;
}
.v-item--active::before  {
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
}

.v-expansion-panel-content >>> .v-expansion-panel-content__wrap {
  padding: 0 12px 0px 12px !important;
}
.v-expansion-panel-content:not(:last-child) {
  border-bottom: 1px solid rgba(0, 0, 0, 0.2);
}
.v-card {
  -webkit-box-shadow: none;
  box-shadow: none;
  margin-top: 5px;
}
.v-item-group{
  margin-bottom: 6px;
}
</style>
